import React, { useState, useEffect, Suspense, lazy } from 'react';
import HeroSection from './sections/HeroSection';
import CalendlyPopup from '../components/ui/CalendlyPopup';

// Lazy load sections below the fold for performance
const StatusQuoSection = lazy(() => import('./sections/StatusQuoSection'));
const QualifikationSection = lazy(() => import('./sections/QualifikationSection'));
const AboutSection = lazy(() => import('./sections/AboutSection'));
const TestimonialSection = lazy(() => import('./sections/TestimonialSection'));
const DecisionSection = lazy(() => import('./sections/DecisionSection'));

const SectionLoader = () => <div className="h-40 w-full animate-pulse bg-white/5 rounded-2xl mb-12" />;

const MainPage = () => {
  const [isCalendlyOpen, setIsCalendlyOpen] = useState(false);

  useEffect(() => {
    const handleOpenCalendly = () => setIsCalendlyOpen(true);
    window.addEventListener('open-calendly', handleOpenCalendly);
    return () => window.removeEventListener('open-calendly', handleOpenCalendly);
  }, []);

  return (
    <div className="flex flex-col items-center w-full pb-10 overflow-x-hidden">
      <HeroSection onOpenCalendly={() => setIsCalendlyOpen(true)} />
      
      <Suspense fallback={<SectionLoader />}>
        <StatusQuoSection />
      </Suspense>

      <Suspense fallback={<SectionLoader />}>
        <QualifikationSection />
      </Suspense>

      <Suspense fallback={<SectionLoader />}>
        <AboutSection />
      </Suspense>

      <Suspense fallback={<SectionLoader />}>
        <TestimonialSection />
      </Suspense>

      <Suspense fallback={<SectionLoader />}>
        <DecisionSection onOpenCalendly={() => setIsCalendlyOpen(true)} />
      </Suspense>

      <CalendlyPopup isOpen={isCalendlyOpen} onClose={() => setIsCalendlyOpen(false)} />
    </div>
  );
};

export default MainPage;